import { Search } from "@outschool/business-rules";
import { SearchFilters } from "@outschool/gql-frontend-generated";
import { dayjs } from "@outschool/time";
import React from "react";

const NO_DATE_FILTER: SearchFilters = {};

const DEFAULT_DATE_FILTER: SearchFilters = {
  startBefore: Search.RelativeDateFilter.FourteenDays,
  startAfter: Search.RelativeDateFilter.FourteenDays
};

type ParentDashboardFiltersContextType = {
  dateFilters: SearchFilters;
  setDateFilters: (f: SearchFilters) => void;

  searchFilters: SearchFilters;
  setSearchFilters: (f: SearchFilters) => void;

  userFilters?: string[];
  setUserFilters: (users?: string[]) => void;
};

export const ParentDashboardFiltersContext =
  React.createContext<ParentDashboardFiltersContextType>({
    dateFilters: DEFAULT_DATE_FILTER,
    setDateFilters: () => {},
    searchFilters: {},
    setSearchFilters: () => {},
    userFilters: [],
    setUserFilters: () => {}
  });

export function ParentDashboardFiltersProvider({
  children,
  enabled,
  initialSearchFilters = {},
  initialDateFilters = DEFAULT_DATE_FILTER
}: $TSFixMe) {
  const [localDateFilters, setDateFilters] =
    React.useState<SearchFilters>(initialDateFilters);

  const [searchFilters, setSearchFilters] =
    React.useState<SearchFilters>(initialSearchFilters);
  const [userFilters, setUserFilters] = React.useState([]);

  let dateFilters = localDateFilters;
  if (!enabled) {
    dateFilters = NO_DATE_FILTER;
  } else if (
    dateFilters.startBefore &&
    dayjs(dateFilters.startBefore).isValid() &&
    dayjs(dateFilters.startBefore).isBefore(dayjs().startOf("day"))
  ) {
    setDateFilters(DEFAULT_DATE_FILTER);
    dateFilters = DEFAULT_DATE_FILTER;
  }

  const combinedFilters = React.useMemo(
    () => ({
      ...searchFilters,
      ...dateFilters
    }),
    [searchFilters, dateFilters]
  );

  const value = {
    dateFilters,
    setDateFilters,
    searchFilters: combinedFilters,
    setSearchFilters,
    userFilters,
    setUserFilters
  };

  return (
    // @ts-ignore TS(2322): Type '{ dateFilters: SearchFilters; setDateFilters... Remove this comment to see the full error message
    <ParentDashboardFiltersContext.Provider value={value}>
      {children}
    </ParentDashboardFiltersContext.Provider>
  );
}

export function useParentDashboardFilters(): ParentDashboardFiltersContextType {
  return React.useContext(ParentDashboardFiltersContext);
}
